exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-toast-mask-3wQMk{position:fixed;display:flex;justify-content:center;z-index:10000;top:0;left:0;right:0;bottom:0;pointer-events:none;transition:all .2s linear;background:hsla(0,0%,100%,0);pointer-events:auto;-webkit-animation:index-dui-toast-fade-in-C-8vj .2s linear;animation:index-dui-toast-fade-in-C-8vj .2s linear}", ""]);

// Exports
exports.locals = {
	"toast-mask": "index-toast-mask-3wQMk",
	"dui-toast-fade-in": "index-dui-toast-fade-in-C-8vj"
};